// Per-VALUE text direction for the סקירה tab.
//
// The page is RTL, so labels ("אימייל", "ת״ז") are always RTL — but the VALUES
// are user data and must pick their own direction from their content: an email,
// a URL or an ID number reads LTR; a Hebrew name or address reads RTL.
//
// `dir="auto"` is the browser's own answer to this, but it resolves from the
// FIRST STRONG DIRECTIONAL CHARACTER — so a value with no letter at all
// (a ת״ז like "123456789", a floor range "3+", a budget "2.5–3") has nothing
// to resolve from and silently falls back to the PARENT direction. Under RTL
// that reorders neutrals around numbers: "3+" renders "+3", "+972" renders
// "972+". Those values need an explicit dir="ltr".
//
// Hence one rule, applied per value:
//   has at least one strong (letter) character → "auto"  (browser decides)
//   digits / punctuation only                  → "ltr"   (never mirror numbers)
//
// Deliberately NOT \p{L}: unicode property escapes need the /u flag and a
// regex-level transform this CRA/babel setup does not guarantee. The explicit
// ranges below cover every script this app renders (Latin + its supplements,
// Greek, Cyrillic, Hebrew, Arabic, Syriac) and are written as \u escapes so the
// pattern survives any file-encoding round-trip.
const STRONG_DIRECTIONAL_CHAR =
  /[A-Za-z\u00C0-\u024F\u0370-\u03FF\u0400-\u04FF\u0590-\u05FF\u0600-\u06FF\u0700-\u074F]/;

/**
 * The `dir` attribute a rendered VALUE should carry.
 *
 * Pass the exact string the user will see. Empty/absent values return "ltr",
 * which is inert (nothing is rendered).
 */
export function valueDir(value: string | null | undefined): "auto" | "ltr" {
  return value && STRONG_DIRECTIONAL_CHAR.test(value) ? "auto" : "ltr";
}
